import { HelpRequestEventName } from './types';

export const handleClose = () =>
  window.dispatchEvent(new CustomEvent(HelpRequestEventName));
